/**
 * 游戏业务弹窗
 */
export default {
  dbl_game_no_access_title: '拒绝访问',
  dbl_game_no_access_content: '抱歉，您无权访问当前业务。如需申请权限，请联系以下团队成员：sallyxue、v_blljli 或 ivyyfchen。',
  dbl_game_no_access_confirm: '我知道了',
};